module.exports = __webpack_public_path__ + "static/media/kid_1_icon.d9a02d1c.jpg";